require("./index.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "activeExtensions",
              "marketplace"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Aside/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    DBlock_template = require("./components/DBlock.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    DBlock_tag = marko_loadTag(DBlock_template),
    Marketplace_template = require("../Marketplace/index.marko"),
    Marketplace_tag = marko_loadTag(Marketplace_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "position-relative height-100vh border-left"
      };

function render(input, out, __component, component, state) {
  var data = input;

  WSAdapt_tag({
      ns: "d-none",
      qs: "col-lg-3 col-sm-12",
      hs: "col-lg-6 col-sm-12",
      fs: "position-absolute col-12 zindex-5",
      class: "Aside theme-bg-fade overflow-hidden p-0",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        if (state.activeExtensions && (!isEmpty(state.activeExtensions))) {
          marko_forIn(state.activeExtensions, function(id, value) {
            DBlock_tag({
                id: id,
                options: value
              }, out, __component, "block-" + value.zindex);
          });
        }

        out.ee();

        if (state.marketplace) {
          Marketplace_tag({}, out, __component, "2");
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
